<template>
  <div>
    <table-top
      page-size-start
      @fetch="fetchCycleTime"
    />
    <data-table
      class="my-5"
      :table-header="cycleTimeHeaders"
      :table-data="cycleTimeData"
      :sort-by="filter.sort_by"
      :sort-dir="filter.sort_dir"
      @sort="sortTable"
    >
      <template #cycle_time="{ row }">
        <span>{{ row.cycle_time ? Number(row.cycle_time).toFixed(2) : '-' }}</span>
      </template>
      <template #coal_info="{ row }">
        <span
          :class="[row.coal_info.toLowerCase().includes('itm')
            ? 'coal-info-itm-bg'
            : 'coal-info-other-bg']"
        >
          {{ row.coal_info }}
        </span>
      </template>
    </data-table>
    <table-bottom @fetch="fetchCycleTime" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import downloadUtils from '@/utils/downloadUtils'

export default {
  components: {
    DataTable,
    TableBottom,
    TableTop
  },
  props: {
    dateRange: {
      type: Array,
      default: () => []
    },
    isFetch: {
      type: Boolean,
      default: () => false
    },
    isDownload: {
      type: Boolean,
      default: () => false
    }
  },
  beforeCreate() {
    this.$store.dispatch('Table/resetConfig')
  },
  data() {
    return {
      filter: {
        sort_by: null,
        sort_dir: null
      },
      cycleTimeHeaders: [
        { key: 'route', label: 'Route', sortable: true },
        { key: 'cycle_time', label: 'Cycle Time', sortable: true },
        { key: 'coal_info', label: 'Coal Info', sortable: true }
      ],
      cycleTimeData: []
    }
  },
  computed: {
    ...mapGetters({
      cycleTimeItems: 'CycleTime/cycleTimes',
      cycleTimeFile: 'CycleTime/cycleTimeFile'
    })
  },
  watch: {
    isFetch: {
      handler(val) {
        if (val) {
          this.fetchCycleTime()
        }
      }
    },
    isDownload: {
      handler(val) {
        if (val) {
          this.downloadCycleTimeExcel()
        }
      }
    },
    cycleTimeItems: {
      handler(val) {
        this.cycleTimeData = val
      }
    },
    cycleTimeFile: {
      handler(val) {
        if (val) {
          downloadUtils(val, `cycle_time_${this.dateRange[0]}_${this.dateRange[1]}.xls`)
          this.$store.dispatch('CycleTime/resetFile')
        }
      }
    }
  },
  methods: {
    async fetchCycleTime() {
      if (!this.isDateEmpty()) {
        try {
          await this.$store.dispatch('CycleTime/fetchCycleTimes', {
            start_date: this.moment(this.dateRange[0], 'DD-MMM-YYYY').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            end_date: this.moment(this.dateRange[1], 'DD-MMM-YYYY').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            ...this.filter
          })
          this.$emit('update:isFetch', false)
        } catch (err) {
          this.$emit('update:isFetch', false)
          this.showFailedNotification(this, 'Failed to fetch cycle times')
        }
        return
      }

      this.$emit('update:isFetch', false)
      this.showWarningNotification(this, 'Please pick date first')
    },
    async downloadCycleTimeExcel() {
      if (!this.isDateEmpty()) {
        try {
          await this.$store.dispatch('CycleTime/downloadCycleTimes', {
            start_date: this.moment(this.dateRange[0], 'DD-MMM-YYYY').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            end_date: this.moment(this.dateRange[1], 'DD-MMM-YYYY').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
          })
          this.$emit('update:isDownload', false)
        } catch (err) {
          this.$emit('update:isDownload', false)
          this.showFailedNotification(this, 'Cannot download excel file, please try again')
        }
        return
      }

      this.$emit('update:isDownload', false)
      this.showWarningNotification(this, 'Please pick date first')
    },
    sortTable(sortBy, sortDir) {
      this.filter.sort_by = sortBy
      this.filter.sort_dir = sortDir

      this.$emit('update:isFetch', true)
      this.fetchCycleTime()
    },
    isDateEmpty() {
      return !this.dateRange.length || !this.dateRange[0] || !this.dateRange[1]
    }
  }
}
</script>

<style lang="scss" scoped>
.coal-info-itm-bg {
  @apply px-3 py-1 text-primary font-semibold rounded-2xl;

  background-color: rgba(#CDC6E1, 0.35);
}

.coal-info-other-bg {
  @apply px-3 py-1 bg-secondary-accent text-secondary font-semibold rounded-2xl;
}
</style>
